// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import CartPageTemplate, { CartPageTemplateStyles } from "@keller/App/Components/Cart/CartPageTemplate";
import XngZone from "@keller/App/Components/Common/XngZone";
import { CheckoutStepper } from "@keller/App/Widgets/CheckoutStepper/CheckoutStepper";
import { CHECKOUT_STEPS } from "@keller/App/Widgets/CheckoutStepper/CheckoutStepper.helper";
import { StepperContext } from "@keller/App/Widgets/CheckoutStepper/StepperContext";
import React, { FC, useContext } from "react";

interface OwnProps extends WidgetProps {}

type Props = OwnProps;

export interface CheckoutPageContainerStyles extends CartPageTemplateStyles {
    cartPageTemplateStyles?: CartPageTemplateStyles;
    headerTitle?: TypographyPresentationProps;
    cartApprovalMessagesWrapper?: InjectableCss;
}

export const checkoutPageContainerStyles: CheckoutPageContainerStyles = {};

const styles = checkoutPageContainerStyles;

const CheckoutPageContainer: FC<Props> = ({ id }) => {
    const { currentStep } = useContext(StepperContext);

    return (
        <CartPageTemplate extendedStyles={styles.cartPageTemplateStyles}>
            <CartPageTemplate.HeaderSection>
                <Typography {...styles.headerTitle}>{translate("Checkout")}</Typography>
                <CheckoutStepper />
            </CartPageTemplate.HeaderSection>
            <CartPageTemplate.MainSection>
                <StyledWrapper {...styles.cartApprovalMessagesWrapper}>
                    <XngZone contentId={id} zoneName="Content0" hint="Zone For Header (Cart Approval message)" />
                </StyledWrapper>
                <XngZone
                    contentId={id}
                    zoneName="Content1"
                    hint="Zone For Step Content (Shipping container, Submit & Review container)"
                />
            </CartPageTemplate.MainSection>
            <CartPageTemplate.CartTotalSection className={currentStep === CHECKOUT_STEPS.REVIEW && "review-step"}>
                <XngZone contentId={id} zoneName="Content2" hint="Zone For Checkout Total" />
            </CartPageTemplate.CartTotalSection>
            <CartPageTemplate.ActionsSection>
                <XngZone contentId={id} zoneName="Content3" hint="Zone For Stepper Actions" />
            </CartPageTemplate.ActionsSection>
        </CartPageTemplate>
    );
};

const widgetModule: WidgetModule = {
    component: CheckoutPageContainer,
    definition: {
        group: "Checkout - Shipping",
        allowedContexts: ["CheckoutShippingPage", "CheckoutReviewAndSubmitPage"],
        displayName: "Checkout Page Container",
        fieldDefinitions: [],
    },
};

export default widgetModule;
